import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Icon from '../index.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'headEdit',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Icon, {
    name: "head-edit",
    viewBox: "0 0 20 20"
  }))
}
}

})